import { FC, PropsWithChildren, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useUser } from 'shared/hooks'
import { tokenStorage } from 'shared/services'

interface PrivateRouteProps {
  children: ReactNode
  allowedRole?: string[]
}

const PrivateRoute: FC<PropsWithChildren<PrivateRouteProps>> = ({ children, allowedRole }) => {
  const location = useLocation()
  const auth = tokenStorage.get()
  const user = useUser()
  // console.log('user in private route', user, auth)

  if (!auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={'/login'} state={{ from: location }} replace />
  }

  if (!allowedRole || allowedRole.length === 0) {
    return <>{children}</>
  }

  if (!user) {
    return <Navigate to={'/login'} state={{ from: location }} replace />
  }

  try {
    if (!user?.roles) {
      return <Navigate to={'/login'} state={{ from: location }} replace />
    }

    const hasAccess = user.roles.some((role: string) => allowedRole.includes(role))

    if (!hasAccess) {
      return <Navigate to={'/'} state={{ from: location }} replace />
    }

    return <>{children}</>
  } catch (error) {
    console.error('Error parsing user data:', error)
    return <Navigate to={'/login'} state={{ from: location }} replace />
  }
}

export default PrivateRoute
